import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import getHelp from '../../../data/getHelp'
import { bindActionCreators } from 'redux'
import rootActions from 'actions/rootActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StandardModalContent from '../StandardModalContent/StandardModalContent.jsx'

/**
 * General help button
 * @param  {[string]} [id] Specifier used to identify the proper help message
 *                         to display from \data\Help.js
 */
const Help = props => {
  const { id, clickHandler, openModal } = props
  const getHelpWrapper = e => {
    const helpContent = getHelp(id)
    openModal('help-modal', {
      title: 'Help',
      content: (
        <HelpModal
          messageContent={helpContent}
          okHandler={() => {
            props.closeModal('help-modal')
          }}
          closeSelf={props.closeSelf}
        />
      ),
      closeable: true
    })
  }
  const callback = clickHandler || getHelpWrapper
  return (
    <div className="help-btn">
      <div
        className="btn"
        role="button"
        onClick={e => {
          callback(e)
        }}
      >
        {clickHandler ? (
          <FontAwesomeIcon icon={['fas', 'info']} />
        ) : (
          <FontAwesomeIcon icon={['far', 'question-circle']} />
        )}
      </div>
    </div>
  )
}

Help.propTypes = {
  // Required unique identifier used to fetch help text from the data/help.js
  // file.
  id: PropTypes.string,
  // clickHandler to run if the default help dialog is not going to be shown
  clickHandler: PropTypes.func
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(null, mapDispatchToProps)(Help)

const HelpModal = props => {
  return (
    <div className="help-modal">
      <StandardModalContent
        closeSelf={props.closeSelf}
        messageContent={props.messageContent}
        okHandler={props.okHandler}
        okText={'CLOSE'}
      />
    </div>
  )
}

// add this css in for the 1.04 project
// .settings-item .help-btn *
//   color var(--red-color)
